import eligibilityData from '../../data/ghgReportEligibility2023.json';

type EligibilityRow = {
  capName: string;
  prototypeEligible2023: boolean;
  inFrozen2023Universe: boolean;
  failureReasons: string[];
};

const MAP = eligibilityData as Record<string, EligibilityRow>;

export function getPrototypeEligibility(stableJurisdictionId: string | null): EligibilityRow | null {
  if (!stableJurisdictionId) return null;
  return MAP[stableJurisdictionId] ?? null;
}

export function isPrototypeEligible2023(stableJurisdictionId: string | null): boolean {
  const row = getPrototypeEligibility(stableJurisdictionId);
  return row?.prototypeEligible2023 === true;
}
